/**
 * Suspense fallback for route-level code-split pages/tabs (Issue 3 - Overall Platform/Home:
 * slow page loads). Deliberately renders no background color of its own - it inherits
 * whichever container it's placed in (e.g. AppShell's `<main>`) instead of flashing a
 * mismatched black/white frame while the next chunk downloads.
 *
 * Exported from `@tracekit/core` so any Suspense boundary in this app or a plugin (including
 * layout/router-level boundaries) can reuse the same themed, no-flash loading state instead of
 * each screen inventing its own.
 */

import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

export interface PageLoadingFallbackProps {
  /** Tailwind min-height utility for the centering container. Defaults to '50vh'. */
  minHeight?: string;
}

export function PageLoadingFallback({ minHeight = '50vh' }: PageLoadingFallbackProps) {
  return (
    <div className="flex items-center justify-center" style={{ minHeight }}>
      <LoadingSpinner size="lg" />
    </div>
  );
}

export default PageLoadingFallback;
